import { RecordUtils } from "@rsm-hcd/javascript-core";
import { Record } from "immutable";
import { ChecklistItemNoteSection } from "models/interfaces/checklist-item-notes/checklist-item-note-section";
import SectionRecord from "models/view-models/section-record";

const defaultValues: ChecklistItemNoteSection =
    RecordUtils.auditableDefaultValuesFactory<ChecklistItemNoteSection>({
        checklistItemNoteId: 0,
        section: undefined,
        sectionId: 0,
    });

export class ChecklistItemNoteSectionRecord
    extends Record(defaultValues)
    implements ChecklistItemNoteSection
{
    constructor(params?: Partial<ChecklistItemNoteSection>) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        if (params.section != null) {
            params.section = RecordUtils.ensureRecord(
                params.section,
                SectionRecord
            );
        }

        super(params);
    }

    public with(
        values: Partial<ChecklistItemNoteSection>
    ): ChecklistItemNoteSectionRecord {
        return new ChecklistItemNoteSectionRecord(
            Object.assign(this.toJS(), values)
        );
    }
}
